export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '',
  appId: 'MidApp',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '0.0.1'
};